import React, { useMemo, useState } from "react";
import {  useSelector } from "react-redux";
import { Upload, message, Tooltip } from "antd";
import { LoadingOutlined,UploadOutlined } from "@ant-design/icons";
import { authenticationService, companyService } from "../../app/services";
import { useDispatch } from "react-redux";
import { setProfileImage } from "../../app/services/user.slice";

const AvatarUploader = ({  isCompany = false, onProfileUpdated }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
    const profile = useSelector((state) => state.user.profile);

  const handleUpload = async ({ file }) => {
    setLoading(true);
    try {
      let response;

      const formData = new FormData();
      formData.append("file", file);

      if (profile?.type === "Pro") {
        response = await authenticationService.uploadCompanyLogo(formData);
        dispatch(setProfileImage(response.data.profileImage));
        message.success("Company logo updated!");
      } else {
        response = await authenticationService.uploadUserProfileImage(formData);
        dispatch(setProfileImage(response.data.profileImage));
        message.success("Profile image updated!");
      }

      // if (onProfileUpdated) {
      //   profile.profileImage = response.data.profileImage;
      //   onProfileUpdated(profile);
      // }

    } catch (error) {
      console.error(error);
      message.error("Failed to upload image");
    } finally {
      setLoading(false);
    }
  };

  const displayName = (profile?.name || profile?.username || "").toString();
  const initial = (displayName.trim()[0] || "U").toUpperCase();
  const [avatarError, setAvatarError] = useState(false);
  const src = profile?.profileImage || profile?.logo || null;
  const showImage = !!src && !avatarError;
  const color = useMemo(() => {
    const palette = ["#0ea5e9", "#22c55e", "#ef4444", "#a855f7", "#f59e0b", "#14b8a6", "#6366f1"];
    let hash = 0;
    for (let i = 0; i < displayName.length; i++) hash = (hash << 5) - hash + displayName.charCodeAt(i);
    return palette[Math.abs(hash) % palette.length];
  }, [displayName]);

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        marginBottom: "24px",
      }}
    >
      {/* Avatar: image if valid, otherwise colored initial */}
      {showImage ? (
        <img
          src={src}
          alt={isCompany ? "Company Logo" : "User Avatar"}
          onError={() => setAvatarError(true)}
          style={{
            width: 96,
            height: 96,
            borderRadius: "50%",
            objectFit: "cover",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            border: "1px solid #e5e7eb",
          }}
        />
      ) : (
        <div
          aria-hidden
          style={{
            width: 96,
            height: 96,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 900,
            color: "#fff",
            background: color,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            border: "1px solid #e5e7eb",
            textTransform: "uppercase",
            fontSize: 36,
          }}
          title={displayName}
        >
          {initial}
        </div>
      )}

      {/* Small button in bottom-right corner */}
      <Upload showUploadList={false} customRequest={handleUpload} >
        <Tooltip title="Change image">
          <div
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              backgroundColor: "#1890ff",
              borderRadius: "50%",
              width: 28,
              height: 28,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
          >
            {loading ? (
              <LoadingOutlined style={{ color: "white", fontSize: 14 }} spin />
            ) : (
              <UploadOutlined style={{ color: "white", fontSize: 14 }} />
            )}
          </div>
        </Tooltip>
      </Upload>
    </div>
  );
};

export default AvatarUploader;
